import { z } from 'zod'
import { ReboundPostalServices, ReboundSalesItem } from '../types'
import { ZSizes } from './returnSchema'

export const ZClientMetadata = z.array(
  z.object({ key: z.string(), value: z.string().nullable() })
)

export const ZPicture = z.object({ url: z.string() })

export const ZExchangeOptionNameNew = z.enum([
  'Waist',
  'Build',
  'Leg',
  'ShortsLeg',
  'Size',
  'Cut',
  'Length'
])

export const ZReboundPostalService: z.ZodType<ReboundPostalServices> = z
  .object({
    id: z.union([z.number(), z.string()]),
    logo: z.string().optional().nullable(),
    displayName: z.string().optional(),
    byline: z.string(),
    message: z.string(),
    modal_byline: z.string(),
    modal_message: z.string(),
    modal_title: z.string(),
    postalCompanyId: z.number().optional(),
    collectionDates: z.array(z.string()).default([]).optional(), // [] type → empty array or any array
    title: z.string(),
    type: z.string().optional()
  })
  .passthrough()

export const ZRebountPostalServiceValidator = z.array(ZReboundPostalService)

export const ZSalesItemValidator: z.ZodType<ReboundSalesItem> = z
  .object({
    productType: z.string(),
    sku: z.string(),
    title: z.string(),
    color: z.string(),
    commercialValue: z.object({
      amount: z.number(),
      currency: z.string()
    }),
    fullPrice: z.string(),
    sizes: ZSizes,
    pictures: z.array(ZPicture).optional(),
    clientMetadata: ZClientMetadata,
    isMTO: z.boolean(),
    salesItemId: z.string().optional(),
    isReturnable: z.boolean().optional().default(true),
    isExchangeable: z.boolean().optional().default(true),
    exchangeOptions: z
      .array(
        z.object({
          name: ZExchangeOptionNameNew.or(z.string()),
          type: z.string(),
          values: z.array(z.string()).nonempty()
        })
      )
      .default([])
  })
  .strict()

export type SalesItemParsed = z.infer<typeof ZSalesItemValidator>
